import React from 'react';
import './hamburger.scss';

const Hamburger = ({ onClick, isOpen }) => {
    return (
        <div className={`hamburger ${isOpen ? 'open' : ''}`} onClick={onClick}>
            <div className='hamburger__line'></div>
            <div className='hamburger__line'></div>
            <div className='hamburger__line'></div>
        </div>
    )
};

export default Hamburger;
